import { setEditJobExamDeadlineModal, setSelectedJob } from '../../../../../store/workspace/slice';
import { endExamThunk, getJobsThunk } from '../../../../../store/workspace/thunks';
import { selectSelectedJob } from '../../../../../store/workspace/selectors';
import { useDispatch, useSelector } from '../../../../../store/store';
import { setNotification } from '../../../../../store/general/slice';
import { EditSquareIcon } from '../../../../../assets/icons';
import CustomCalendar from '../../../../../components/Calendar';
import Modal from '../../../../../components/Modal';
import { useEffect, useState } from 'react';
import { DayValue } from '@amir04lm26/react-modern-calendar-date-picker';
import { formatDate, fromDatePickerFormat, toDatePickerFormat } from '../../../../../utils/dateHelpers';
import styles from './style.module.scss';

export default function EditJobExamDeadline() {
    const dispatch = useDispatch();
    const job = useSelector(selectSelectedJob);
    const [loading, setLoading] = useState(false);
    const [deadline, setDeadline] = useState<DayValue>();

    const closeModal = () => dispatch(setEditJobExamDeadlineModal(false));

    useEffect(() => {
        if (!job) return;
        setDeadline(toDatePickerFormat(job.multipleChoiceExamDeadline));
    }, [job]);

    const updateDeadline = () => {
        if (!job || !deadline) return;

        setLoading(true);
        dispatch(endExamThunk({
            id: job.id,
            action: 'edit',
            endDate: fromDatePickerFormat(deadline),
        }))
            .unwrap()
            .then(() => {
                dispatch(getJobsThunk({}));
                dispatch(setSelectedJob(null));
                dispatch(setEditJobExamDeadlineModal(false));
                dispatch(setNotification(['Job updated successfully', 'success']));
            })
            .catch(() => {
                dispatch(setNotification(['Something went wrong,Try again...', 'error']));
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <Modal
            size='sm'
            actions='both'
            closeFunc={closeModal}
            icon={<EditSquareIcon />}
            title='Update exam deadline'
            childClassName={styles.wrapper}
            dismissButton={{
                text: 'Cancel',
                type: 'Outline-Dark',
                onClick: closeModal,
            }}
            confirmButton={{
                text: 'Update',
                type: 'Primary',
                loading: loading,
                onClick: updateDeadline,
                disabled: !deadline || !job,
            }}
        >
            <CustomCalendar
                selectedDate={deadline}
                setSelectedDate={setDeadline}
                minimumDate={toDatePickerFormat(formatDate(new Date())) || undefined}
            />
        </Modal>
    );
};
